// extracted by mini-css-extract-plugin
module.exports = {"actions":"EAuthorization_actions__7YII7","hidden":"EAuthorization_hidden__3AjF7"};